/**
 * <ExportMenu> — top-right export trigger used by Transactions / Reconciliation
 * / Statement / Accounts. Provides:
 *
 *   - Print (window.print)
 *   - Browser-only CSV / XLSX / PDF / Google-Sheets-friendly CSV
 *   - Steel+ feature: email the export as an attachment (with upsell modal
 *     for Ember tier).
 *
 * This shell only wires the hook + view pieces together. Everything else
 * lives under components/export-menu/: useExportActions (state + side
 * effects), ExportDropdown (button + menu), EmailExportDialog (form),
 * EmailUpsellDialog (Ember-tier pitch).
 *
 * Public API stays identical so every call site is unchanged:
 *   <ExportMenu getData label testIdPrefix pageTitle />
 */
import React from 'react';
import useExportActions from './export-menu/useExportActions';
import ExportDropdown from './export-menu/ExportDropdown';
import EmailExportDialog from './export-menu/EmailExportDialog';
import EmailUpsellDialog from './export-menu/EmailUpsellDialog';

const ExportMenu = ({ getData, label = 'Export', testIdPrefix = 'export', pageTitle }) => {
  const ex = useExportActions({ getData, pageTitle });

  return (
    <>
      <ExportDropdown
        label={label}
        testIdPrefix={testIdPrefix}
        isPro={ex.isPro}
        pdfBusy={ex.pdfBusy}
        onPrint={ex.handlePrint}
        onCSV={ex.handleCSV}
        onXLSX={ex.handleXLSX}
        onPDF={ex.handlePDF}
        onGoogleSheets={ex.handleGoogleSheets}
        onEmail={ex.openEmailDialog}
      />
      <EmailExportDialog
        open={ex.emailOpen}
        onOpenChange={ex.setEmailOpen}
        testIdPrefix={testIdPrefix}
        emailForm={ex.emailForm}
        setEmailForm={ex.setEmailForm}
        emailing={ex.emailing}
        onSubmit={ex.submitEmail}
      />
      <EmailUpsellDialog
        open={ex.upsellOpen}
        onOpenChange={ex.setUpsellOpen}
        testIdPrefix={testIdPrefix}
      />
    </>
  );
};

export default ExportMenu;
